import { IsOptional, IsString } from 'class-validator';

import { IOrderExternalData } from './i-order-external-data';

export class OrderExternalData implements IOrderExternalData {
    @IsOptional()
    @IsString()
    public barCodeInWork: string;

    @IsOptional()
    @IsString()
    public barCodeClosed: string;

    @IsOptional()
    @IsString()
    public contractor: string;

    constructor(data?: IOrderExternalData) {
        if (data) {
            this.barCodeInWork = data.barCodeInWork;
            this.barCodeClosed = data.barCodeClosed;
            this.contractor = data.contractor;
        }
    }
}
